/* Dismissible announcement bar — the promise is stated once, then it gets out of the way. */
(function () {
  var KEY = 'ag-announce-dismissed';
  var bar = document.querySelector('.utility-bar');
  if (!bar) return;

  var stored = null;
  try {
    stored = localStorage.getItem(KEY);
  } catch (e) {}

  if (stored === '1') {
    bar.setAttribute('hidden', '');
    return;
  }

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ag-announce-close';
  btn.setAttribute('aria-label', 'Dismiss');
  btn.textContent = '\u00d7';
  btn.addEventListener('click', function () {
    bar.setAttribute('hidden', '');
    try {
      localStorage.setItem(KEY, '1');
    } catch (e) {}
  });

  bar.classList.add('ag-announce--dismissible');
  bar.appendChild(btn);
})();
